<div class="flex flex-column list-presentation-container list-presentation-row-gap">
  @for (card of cards(); track $index) {
    @switch (card.type) {
      @case (ContentComponentType.CARD_GENERAL) {
        <div class="flex">
          <ppg-list-presentation-general-card
            class="flex-initial flex align-items-center justify-content-center"
            [listGeneralCard]="card" />
        </div>
      }
      @case (ContentComponentType.CARD_ASSET_DOCUMENT) {
        <div class="flex">
          <ppg-list-presentation-asset-document-card
            class="flex-initial flex align-items-center justify-content-center"
            [listAssetDocumentCard]="card" />
        </div>
      }
      @case (ContentComponentType.CARD_ASSET_URL_CONTENT) {
        <div class="flex">
          <ppg-list-presentation-asset-url-card
            class="flex-initial flex align-items-center justify-content-center"
            [listAssetUrlCard]="card" />
        </div>
      }
      @case (ContentComponentType.CARD_ASSET_YOUTUBE_VIDEO) {
        <div class="flex">
          <ppg-list-presentation-asset-youtube-video-card
            class="flex-initial flex align-items-center justify-content-center"
            [listAssetYoutubeVideoCard]="card" />
        </div>
      }
      @case (ContentComponentType.CARD_PAGE) {
        <div class="flex">
          <ppg-list-presentation-page-card
            class="flex-initial flex align-items-center justify-content-center"
            [listPageCard]="card" />
        </div>
      }
    }
  }
</div>
